import { IconArrowUpRight } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import CopyIcon from "../../../../assets/icons/copy.svg?react";
import { displayToast } from "../../../../components/app/AppToast";
import { Button } from "../../../../components/ui/Button";
import type { ArticlePageArticle } from "../../hooks/useArticleData";
import {
  bareDoi,
  doiUrl,
  originalSourceUrl,
} from "../../../../domains/article/utils/sourceUrl";

interface ArticleSectionDoiProps {
  article: ArticlePageArticle;
  handleViewArticleSource: () => void;
}

export function ArticleSectionDoi({
  article,
  handleViewArticleSource,
}: ArticleSectionDoiProps) {
  const bare = article.doi === null ? null : bareDoi(article.doi);
  const doiHref = article.doi === null ? null : doiUrl(article.doi);
  const externalLink = originalSourceUrl(article);
  const { t } = useTranslation();

  if (bare === null && externalLink === null) {
    return null;
  }

  return (
    <section
      data-gtm-section="doi"
      data-gtm-order="14"
      className="flex flex-col gap-4"
    >
      {bare !== null && doiHref !== null && (
        <div className="p-4 flex font-mono text-sm items-center gap-[8px] justify-between bg-secondary-bluegrey-1 border border-secondary-bluegrey-2 rounded-card">
          <a
            href={doiHref}
            target="_blank"
            rel="noreferrer"
            className="truncate text-[#1E2939] hover:underline"
          >
            doi:{bare}
          </a>

          <button
            type="button"
            className="flex items-center gap-[3px] text-[#0000EE] cursor-pointer"
            onClick={() => {
              if (navigator.clipboard !== undefined) {
                navigator.clipboard.writeText(doiHref);
                displayToast(t("Copied"), "success");
              }
            }}
          >
            <CopyIcon />
          </button>
        </div>
      )}

      {externalLink !== null && (
        <a href={externalLink} target="_blank" rel="noreferrer">
          <Button
            variant="outline"
            size="lg"
            className="w-full"
            rightIcon={<IconArrowUpRight stroke={2} />}
            onClick={handleViewArticleSource}
          >
            {t("View original source")}
          </Button>
        </a>
      )}
    </section>
  );
}
